import { InfinitePaginatedList } from '@frontend/components';
import { useTranslation } from '@frontend/i18n';
import { MAX_KEYWORD_LENGTH, MIN_KEYWORD_LENGTH } from '../../constants';
import { useKeywordSearchStore } from '../../providers/keyword-search.provider/keyword-search.provider';
import { useTeamChatApi } from '../../providers/team-chat.provider/team-chat-api-providers/use-team-chat-api';
import { useTeamChatSelector } from '../../providers/team-chat.provider/team-chat.provider';
import { KeywordListItem } from './list-item/keyword-list-item-component';
import { KeywordSearchSkeletonLoader } from './list-item/keyword-list-skeleton-loader.component';

export const KeywordSearchList = () => {
  const { t } = useTranslation('team-chat');
  const api = useTeamChatSelector((ctx) => ctx.api);
  const { useGetMessagesByKeyword } = useTeamChatApi(api);

  const { keyword, attachmentType, inConversations, sender } = useKeywordSearchStore([
    'attachmentType',
    'inConversations',
    'keyword',
    'sender',
  ]);

  const { set: _set, ...queryProps } = useGetMessagesByKeyword(
    {
      keyword: keyword,
      sender: sender,
      attachmentType: attachmentType ?? undefined,
      channels: inConversations,
    },
    {
      enabled: keyword.length >= MIN_KEYWORD_LENGTH && keyword.length <= MAX_KEYWORD_LENGTH,
    }
  );

  return (
    <InfinitePaginatedList
      infiniteQueryProps={queryProps}
      renderListItem={({ listItem: message }) => <KeywordListItem message={message} />}
      skeletonLoader={<KeywordSearchSkeletonLoader />}
      emptyStateConfig={{
        type: 'summary',
        header: t('No results found for "{{keyword}}". Try removing filters to broaden your search.', { keyword }),
      }}
    />
  );
};
